import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useFieldsContext } from './context/FieldsContext';
import { InputContainer, GroupStyled, LabelStyled, } from './styles';
import { SubText } from './utils';
const TextAreaStyled = styled.textarea `
  padding: 0;
  flex: 1 1 0%;
  border: none;
  position: relative;
  outline: none;
`;
export function TextArea(props) {
    const { variant: variantProps, help, error, valid, ...otherProps } = props;
    const { name, variant: contextVariant } = useFieldsContext();
    const variant = variantProps || contextVariant;
    return (_jsxs(InputContainer, { children: [_jsx(GroupStyled, { hasError: !!error, hasValid: !!valid, children: _jsx(LabelStyled, { variant: variant, children: _jsx(TextAreaStyled, { id: name, name: name, ...otherProps }) }) }), _jsx(SubText, { error: error, help: help, valid: valid })] }));
}
//# sourceMappingURL=TextArea.js.map